
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-purple-900 via-purple-800 to-purple-900 text-white">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-purple-400 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/9910db4e977c4892bacf08542838a807/407c1331b92070399587dede53135c16.png" 
                alt="OhMyGAWD Logo" 
                className="h-12 w-12 object-contain"
              />
              <h3 className="font-serif text-3xl font-bold">OhMyGAWD</h3>
            </div>
            <p className="text-purple-200 text-sm leading-relaxed mb-6">
              Your AI-driven digital oracle providing guidance, awareness, wisdom, and direction for the modern spiritual seeker. Powered by OpenAI.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-purple-400/30 hover:border-cyan-400 hover:bg-cyan-400/10 transition-all cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-purple-400/30 hover:border-cyan-400 hover:bg-cyan-400/10 transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-purple-400/30 hover:border-cyan-400 hover:bg-cyan-400/10 transition-all cursor-pointer">
                <i className="ri-discord-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-purple-400/30 hover:border-cyan-400 hover:bg-cyan-400/10 transition-all cursor-pointer">
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Navigate</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <a href="#ask" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  Ask OhMyGAWD
                </a>
              </li>
              <li>
                <a href="#subscribe" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  Subscribe
                </a>
              </li>
              <li>
                <Link to="/support" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a href="https://www.oecd.org/en/topics/ai-principles.html" target="_blank" rel="nofollow noopener noreferrer" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  OECD Compliance
                </a>
              </li>
              <li>
                <a href="#disclaimer" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  Disclaimer
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Connect</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://cybernetix.com" target="_blank" rel="noopener noreferrer" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm flex items-center gap-2 cursor-pointer">
                  Cybernetix Technologies
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </a>
              </li>
              <li>
                <a href="https://cyberalchemy.academy" target="_blank" rel="noopener noreferrer" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm flex items-center gap-2 cursor-pointer">
                  CyberAlchemy Academy
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </a>
              </li>
              <li>
                <a href="mailto:support@cybernetix.com" className="text-purple-200 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  support@cybernetix.com
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="w-full h-48 rounded-lg overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/63d03f744cfba2d1b3faf3d25393c4f5.jpg" 
                alt="Fortune Teller Machine" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-purple-700/50">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-purple-300 text-sm">
              © 2025 OhMyGAWD. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <Link to="/privacy" className="text-purple-300 hover:text-cyan-400 transition-colors cursor-pointer">
                Privacy
              </Link>
              <span className="text-purple-500">•</span>
              <Link to="/terms" className="text-purple-300 hover:text-cyan-400 transition-colors cursor-pointer">
                Terms
              </Link>
              <span className="text-purple-500">•</span>
              <Link to="/support" className="text-purple-300 hover:text-cyan-400 transition-colors cursor-pointer">
                Support
              </Link>
              <span className="text-purple-500">•</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-purple-300 hover:text-cyan-400 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
